import ProdutoFab from './ProdutoFab';

export default ProdutoFab;
